import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Orders from "@/pages/Orders";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import OrderSuccess from "@/pages/OrderSuccess";
import Customize from "@/pages/Customize";
import Hoodies from "@/pages/Hoodies";
import Wishlist from "@/pages/Wishlist";
import Oversized from "@/pages/Oversized";
import NewArrivals from "@/pages/NewArrivals";
import Sweatshirts from "@/pages/Sweatshirts";
import Basics from "@/pages/Basics";
import Signature from "@/pages/Signature";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/men" element={<Category key="men" cat="men" />} />
              <Route path="/women" element={<Category key="women" cat="women" />} />
              <Route path="/hoodies" element={<Hoodies />} />
              <Route path="/sweatshirts" element={<Sweatshirts />} />
              <Route path="/shirts" element={<Basics key="shirts" sub="shirts" />} />
              <Route path="/jeans" element={<Basics key="jeans" sub="jeans" />} />
              <Route path="/oversized" element={<Oversized />} />
              <Route path="/new" element={<NewArrivals />} />
              <Route path="/signature" element={<Signature />} />
              <Route path="/gifts" element={<Category key="gifts" cat="gifts" />} />
              <Route path="/customize" element={<Customize />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
